import styled, { css } from 'styled-components';

export const chipsRowStyle = css`
  flex-wrap: wrap;
  gap: 8px;

  && > * {
    flex: 1 1 100px;
    min-width: 0;
    max-width: max-content;
  }

  && > * * {
    min-width: 0;
  }
`;

const MetaChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-block: 4px;
  padding-inline: ${({ $roundContent }) => ($roundContent ? 4 : 6)}px 8px;
  border-radius: 90px;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.black};
  background: ${({ theme }) => theme.colors.grey1};

  > * {
    min-width: 0;
    padding: 0;
  }
`;

export default MetaChip;
